module.exports = __webpack_public_path__ + "img/card.98d2064f.png";